<template>
	<div :key="computedKey">
		<card>
			<h6 slot="header">Rapporto intervento tecnico</h6>
			<div class="row">
				<div class="col-12 col-md-6 col-lg-3">
					<base-input
						label="Ore motore"
						v-validate="'required'"
						:error="getError('number')"
						v-model="model.engineHour"
						@change="updateServiceHour"
						name="number"
						type="number"
						input-size="form-control-lg"
						placeholder="Inserisci ore totali motore" />
				</div>


				<div class="col-12 col-md-6 col-lg-3">
					<base-input
						label="Ore servizio"
						v-validate="'required'"
						:error="getError('number')"
						v-model="model.serviceEngineHour"
						name="number"
						type="number"
						input-size="form-control-lg"
						placeholder="Ore motore dall'ultima revisione E1" />
				</div>

				<div class="col-12 col-md-6 col-lg-3">
					<div class="form-group">
						<label>Referente</label>
						<el-select
							v-if="site"
							size="large"
							v-model="referent"
							input-class="form-control-lg form-control"
							filterable
							placeholder="Seleziona la fase">
								<el-option
									v-for="option in site.emails"
									:value="option._id"
									:label="option.contactName"
									:key="option._id"
								/>
						</el-select>
					</div>
				</div>
			</div>
		</card>

	
		<revision-worked-details
			:model="model" />
	
		<card>
			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="anomalyDescription">Anomalia/e riscontrata/e</label>
						<textarea placeholder="Scrivi qui" rows="8" name="anomalyDescription" v-model="model.anomalyDescription" id="anomalyDescription" class="form-control"></textarea>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="activityDescription">Descrizione attività</label>
						<textarea rows="8" placeholder="Scrivi qui" name="activityDescription" v-model="model.activityDescription" id="activityDescription" class="form-control"></textarea>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="clientsNote">Note del cliente</label>
						<textarea placeholder="Scrivi qui" name="clientsNote" v-model="model.clientsNote" id="clientsNote" class="form-control text-area-notes"></textarea>
					</div>
				</div>
			</div>
		</card>
		<!-- TODO IMOPRTANTISSIMO -->
		<!-- DEVE ESSERE UN COMPONENTE PERCHè è usato in revisionFInalForm too -->
		<!-- Ci sono solo delle colonne diverse.... -->
		<card> 
			<div slot="header">
				<div class="row align-items-center">
					<div class="col-12 col-md-8">
						<h6>Prodotti utilizzati</h6>
					</div>
					<div class="col-12 col-md-4 text-center text-md-right">
						<base-button
							type="primary"
							@click="addProduct()">
	              			<i class="tim-icons icon-simple-add"></i>
							Aggiungi
						</base-button>
					</div>
				</div>
			</div>
			<el-table :data="model.productsUsed" class="table-product-used">
				<el-table-column
					width="160"
					>
					<template slot-scope="scope">
						<div class="d-flex">
							<base-button type="link" class="text-danger" @click="deleteProductRow(scope.$index)">
											<i class="tim-icons icon-simple-remove"></i>
							</base-button>
							<base-button
								type="link"
								@click="changePosition(scope.$index,-1)"
								:disabled="scope.$index === 0"
								class="m-auto d-block px-2 text-info"
								>
								<i class="tim-icons icon-minimal-up"></i>
							</base-button>	
							<base-button
								type="link"
								:disabled="scope.$index === model.productsUsed.length -1 "
								@click="changePosition(scope.$index,1)"
								class="m-auto d-block px-2 text-info"
								>
								<i class="tim-icons icon-minimal-down"></i>
							</base-button>		
						</div>
					</template>
				</el-table-column>
				<el-table-column
					width="280"
					label="Codice">
					<template slot-scope="scope">
						<base-input 
							@input="checkInputProducts"
							:name="`${scope.$index}code`"
							:error="getError(`${scope.$index}code`)"
							placeholder="Codice"
							v-model="scope.row.code"/>
					</template>
				</el-table-column>
				<el-table-column
					width="400"
					label="Descrizione">
					<template slot-scope="scope">
						<base-input 
							@input="checkInputProducts"
							v-validate="'required'"
							:name="`${scope.$index}description`"
							:error="getError(`${scope.$index}description`)"
							placeholder="Descrizione"
							v-model="scope.row.description"/>
					</template>
				</el-table-column>
				<el-table-column
					width="160"
					label="Quantità">
					<template slot-scope="scope">
						<base-input
							v-validate="'required'"
							type="text"
							step="0,001"
							:name="`${scope.$index}quantity`"
							:error="getError(`${scope.$index}quantity`)"
							placeholder="qta"
							@input="changeTotalAmountOfProduct(scope.row)"
							v-model="scope.row.quantity"/>
					</template>
				</el-table-column>
			</el-table>
		</card>

		<revision-technical-details
			:model="model"/>
		<div class="row justify-content-center" v-if="model.id">
			<div class="col-12 col-md-4">
				<base-checkbox
					v-model="model.sendTechnicalReport">
					Completa e invia report revisione
				</base-checkbox>	
			</div>
		</div>
	
	</div>
</template>
<style lang="scss">
	.table-product-used table{
		margin: auto;
	}
</style>
<style lang="scss" scoped>
	textarea{
		min-height: 240px;
		&.text-area-notes{
			min-height: 0;
		}
	}
</style>
<script>
	import moment from 'moment'
	import { debounce } from "debounce"
	import { mapState, mapActions } from 'vuex'
	import { Select, Option, Table, TableColumn } from 'element-ui'
	import RevisionTechnicalDetails from './RevisionTechnichalDetails.vue'
	import RevisionWorkedDetails from './RevisionWorkedDetails.vue'

	export default {
		name: 'revision-technical-form',
		props:{
			model: Object,
			create: {
				type: Boolean,
				default: false
			},
			site: Object
		},
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[TableColumn.name]: TableColumn,
			[Table.name]: Table,
			RevisionTechnicalDetails,
			RevisionWorkedDetails
		},
		computed: {
			...mapState({
				revisions: state => state.revisions.revisions.docs,
			}),
		},
		methods: {
			...mapActions('revisions', {
				getAllRevisions: 'getAll',
			}),
			changePosition(i,howMuch){
				const destIndex = i + howMuch;
				this.model.productsUsed[i] = this.model.productsUsed.splice(destIndex, 1, this.model.productsUsed[i])[0];
				return this.model.productsUsed;
			},
			addProduct() {
				this.model.productsUsed.push({})
			},
			deleteProductRow(i) {
				this.model.productsUsed.splice(i,1)
			},
			checkInputProducts: debounce(function({target}){
				const lastDescription = this.model.productsUsed[this.model.productsUsed.length-1].description;
				const lastCode = this.model.productsUsed[this.model.productsUsed.length-1].description;
				if (lastDescription !== undefined
					&& lastDescription.length > 0
					&& lastCode !== undefined 
					&& lastCode.length > 0){
					this.model.productsUsed.push({})
				}
				const checkInputsLength = this.model.productsUsed.filter(product => {
					return (product.code === undefined || product.code.length === 0)
						&& (product.description === undefined || product.description.length === 0)
						&& (product.quantity === undefined || product.quantity.length === 0)
				}).length
				if (checkInputsLength > 1) {
					// rimuovi l'ultimo
					this.model.productsUsed.pop()
				}
 			},500),
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
			getLastEOneRevision() {
				console.log(this.revisions)
				this.revisions
					.forEach(rev => {
							if (
								((rev.type.includes('E1') || rev.type.includes('E2') ) && rev.phase === 'technical')
								&& this.lastEone === null

							){
								this.lastEone = rev 
								return true;
							}
							if (
								(rev.type.includes('R1') && rev.phase === 'technical')
								&& this.lastRone === null
								){
								this.lastRone = rev 
								return true;
							}
					});
			},
			calculateServiceHour() {
				if (
					this.model.type.includes('E1') ||
					this.model.type.includes('E2') ||
					this.model.type.includes('E3') ||
					this.model.type.includes('R1') ||
					this.model.type.includes('R2') ||
					this.model.type.includes('R3') ||
					this.model.type.includes('N1') 
					){
					if (this.lastEone){
						console.log( +this.model.engineHour, " - " , this.lastEone.engineHour )
						return +this.model.engineHour  - this.lastEone.engineHour
					}
				}
				
				return null;
			},
			updateServiceHour() {
				if (this.model.id === undefined){
					this.model.serviceEngineHour = this.calculateServiceHour();
					this.computedKey++;
				}
			},
		},
		data() {
			return {
				computedKey: 0,
				lastEone: null,
				lastRone: null,
				referent: null
			}
		},
		async mounted() {

			this.model.sendTechnicalReport = false
			this.model.sendReportTo =  this.model.sendReportTo === undefined ? {
				contact: null,
				newContact: {}
			} :  this.model.sendReportTo;
			await this.getAllRevisions({
				engineId: this.$route.params.engineId,
				limit: 10
			});
			this.getLastEOneRevision()

		},
		watch: {
			site() {
				this.site.emails
					.some((email) => {
						if (email.primary){
							this.referent = email._id
							return email.primary
						}
					})
			},
			referent(newValue) {
				this.site.emails.some(email => {
					if (email._id === newValue){
						this.model.referent = email;
						return true;
					}
				})
			}
		},

	}
</script>